export default {"src":"/_next/static/media/gcp.05f3d772.svg","height":77,"width":95,"blurWidth":0,"blurHeight":0};